import { Descriptions } from "@/components/v2";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { ServicePartnerCollection } from "@rumble-it/common-lib/types/models/ServicePartnerCollection.interface";
import { Button, Card } from "@rumbledirect/ui";
import { UseMutationResult } from "@tanstack/react-query";
import { Popconfirm, Space, type DescriptionsProps } from "antd";
import { Link } from "react-router-dom";

interface ServicePartnerCollectionDetailCardProps {
  servicePartnerCollection: ServicePartnerCollection | undefined;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const ServicePartnerCollectionDetailCard = ({
  servicePartnerCollection,
  isLoading,
  deleteMutation,
}: ServicePartnerCollectionDetailCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Naam",
      children: servicePartnerCollection?.name,
    },
    {
      label: "Beschrijving",
      children: servicePartnerCollection?.description || "-",
    },
  ];

  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Subnetwerk"
      extra={
        <Space>
          <Link
            to={`/service-partners/collections/${servicePartnerCollection?.id}/edit`}
          >
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="Subnetwerk verwijderen"
            description="Weet je zeker dat je dit subnetwerk wil verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      <Descriptions items={items} />
    </Card>
  );
};
